<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" hide-details />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" hide-details />
            </v-col>
          </v-row>
        </div>

        <div class="mb-4">
          <SectionSettingsContainerFuild :settings="fields.settings" :container-page="fields.containerPage" />
        </div>

        <div class="mb-4">
          <label class="label-input">Header</label>
          <div class="group-item">
            <ckeditor :editor="editor" v-model="fields.header.html" :config="editorConfig" />
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Compare Images</label>
          <v-row>
            <v-col cols="12" md="6">
              <div class="group-item">
                <div class="font-weight-bold mb-2">Left Image</div>
                <UploadImage
                  @callback="obj => handleUploadImage(obj, 'left')"
                  :image="{ imageSrc: fields.image.left }"
                  :height="`250`"
                  @callbackDelete="handleRemoveImage('left')"
                />
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="group-item">
                <div class="font-weight-bold mb-2">Right Image</div>
                <UploadImage
                  @callback="obj => handleUploadImage(obj, 'right')"
                  :image="{ imageSrc: fields.image.right }"
                  :height="`250`"
                  @callbackDelete="handleRemoveImage('right')"
                />
              </div>
            </v-col>
          </v-row>
          <v-slider
            v-model="fields.image.initialPercent"
            label="Initial slider position (%)"
            min="10"
            max="90"
            thumb-label
            hide-details
            class="mt-4"
          />
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '../common/html/update.js';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';

export default {
  name: 'gatorz-compare-image-section-editor',
  components: {
    SectionSettingsContainerFuild,
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Gatorz Compare Image',
        enableAnchor: false,
        settings: {
          paddingTop: true,
          paddingBottom: true,
          backgroundColor: '#FFFFFF',
          textColor: '#000000',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
        },
        containerPage: {
          enableStyle: false,
          background: '#FFFFFF',
        },
        header: {
          html: '',
        },
        image: {
          left: '',
          right: '',
          initialPercent: 50,
        },
      },
    };
  },
  mounted() {
    this.applyExtract(this.sectionEditor.sectionExtract);
  },
  watch: {
    sectionEditor: {
      handler(newVal) {
        if (newVal && newVal.sectionExtract) {
          this.applyExtract(newVal.sectionExtract);
        }
      },
      deep: true,
    },
  },
  methods: {
    applyExtract(extract) {
      if (!extract) return;
      this.fields = {
        ...this.fields,
        ...extract,
        settings: { ...this.fields.settings, ...(extract.settings || {}) },
        containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
        header: { ...this.fields.header, ...(extract.header || {}) },
        image: { ...this.fields.image, ...(extract.image || {}) },
      };
    },
    handleUploadImage(obj, side) {
      if (!obj || !obj.imageSrc) return;
      if (side === 'left') {
        this.fields.image.left = obj.imageSrc;
      } else {
        this.fields.image.right = obj.imageSrc;
      }
    },
    handleRemoveImage(side) {
      if (side === 'left') {
        this.fields.image.left = '';
      } else {
        this.fields.image.right = '';
      }
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionGatorzCompareImage(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
